import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import styles from './HeaderItem.module.css'

const HeaderItem = ({ name, path }) => {
  return (
    <li className={styles.container}>
      <Link to={path}>{name}</Link>
    </li>
  )
}

HeaderItem.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
}

export default HeaderItem
